/**
 * DetailTip component.
 */
import Container from '@components/atoms/container/detailTipContainer';
import Tip from '@components/elements/tip/tip';

/**
 * Accessibility / hint row above the event title.
 */
export default function DetailTip() {
  return (
    <Container>
      <Tip />
    </Container>
  );
}
